export const VIRTUAL_SECURITY_TYPE = "Virtual";